<script lang="ts">
	import type { URLState } from '../url-state';
	import type { IdMap, SummaryLine_t } from '../types';
	import { getSummary } from '../api';
	import { navigateTo } from '../url-state';
	import SortingHeader from './SortingHeader.svelte';

	let { urlState, id2trefwoord } = $props<{
		urlState: URLState;
		id2trefwoord: IdMap<string>;
	}>();

	type SummaryCompare_t = (a: SummaryLine_t, b: SummaryLine_t) => number;
	
	let mydata = $state<{
		summary: SummaryLine_t[];
		id2trefwoord: IdMap<string>;
		totaal: number;
		totaal_pm: number;
	}>({
		summary: [],
		id2trefwoord: {},
		totaal: 0,
		totaal_pm: 0
	});
	
	let order = $state<1 | -1>(1);
	let sortnr = $state(0);

	function headClick(n: number) {
		sortnr = n;
		order *= -1;
	}

	function compare(a: string | number, b: string | number) {
		return a < b ? -order : a > b ? order : 0;
	}

	const sortfunct: SummaryCompare_t[] = [
		(a, b) => {
			const ta = mydata.id2trefwoord[a.trefwoordId]?.toLowerCase() || '';
			const tb = mydata.id2trefwoord[b.trefwoordId]?.toLowerCase() || '';
			return compare(ta, tb);
		},
		(a, b) => compare(a.bedrag, b.bedrag),
		(a, b) => compare(a.permaand, b.permaand)
	];

	// Derived value for sorted summary data
	let sortedSummary = $derived([...mydata.summary].sort(sortfunct[sortnr]));

	async function loadData() {
		if (urlState.from && urlState.until) {
			try {
				mydata = await getSummary(urlState.from, urlState.until);
			} catch (error) {
				console.error('Failed to load summary:', error);
			}
		}
	}

	function handleTrefwoordClick(trefwoordId: number) {
		navigateTo(`/pertrefwoord/${trefwoordId}`, {
			...urlState,
			trefwoordId
		});
	}

	// Auto-load data when URL state changes
	$effect(() => {
		if (urlState.from && urlState.until) {
			loadData();
		}
	});
</script>

<main>
	<h1>Overzicht</h1>
	{#if mydata.summary.length > 0}
		<article class="summary">
			<SortingHeader n={0} {sortnr} {headClick} {order} title="Trefwoord" />
			<SortingHeader n={1} {sortnr} {headClick} {order} title="Bedrag" />
			<SortingHeader n={2} {sortnr} {headClick} {order} title="€/mnd" />

			{#key order}
				{#each sortedSummary as line (line.trefwoordId)}
					<div 
						class="row" 
						onclick={() => handleTrefwoordClick(line.trefwoordId)}
						onkeydown={(e) => e.key === 'Enter' && handleTrefwoordClick(line.trefwoordId)}
						role="button"
						tabindex="0"
					>
						<div>{mydata.id2trefwoord[line.trefwoordId] || id2trefwoord[line.trefwoordId] || '?'}</div>
						<div class="right">{line.bedrag}</div>
						<div class="right">{line.permaand}</div>
					</div>
				{/each}
			{/key}
			<div 
				class="row"
				onclick={() => handleTrefwoordClick(0)}
				onkeydown={(e) => e.key === 'Enter' && handleTrefwoordClick(0)}
				role="button"
				tabindex="0"
			>
				<div class="footer">Totaal</div>
				<div class="footer right">{mydata.totaal}</div>
				<div class="footer right">{mydata.totaal_pm}</div>
			</div>
		</article>
	{:else}
		<article class="summary">Moment...</article>
	{/if}
</main>

<style>
	.summary {
		width: 15em;
		display: grid;
		grid-template-columns: 12em 7em 7em;
		margin-top: 1em;
	}
	.summary > .row > div {
		border-bottom: 1px solid black;
		padding: 0 0.4em;
	}
	.footer {
		border-top: 1px solid black;
		border-bottom: 1px solid black;
		padding: 0 0.4em;
		font-weight: bold;
		background: #ccc;
	}
	.row {
		display: contents;
		cursor: pointer;
	}
	.row:hover > div {
		background: yellow;
	}
	.right {
		text-align: right;
	}
</style>
